export default () => ({
  coursesFetchStatus: null,
  courses: [],
  popularCoursesFetchStatus: null,
  latestCoursesFetchStatus: null,
  latestCourses: [],
  popularCourses: [],
  memberCourses: [],
  memberLearning: {},
  resources: {},
  assessments: {},
  recentCourse: {},
  badges: [],
  isProcessing: false
})
